import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateEssOperatingState',
})
export class TranslateEssOperatingStatePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}
  transform(value: string): string {
    if (value && this.customTranslationsService.ESS_OPERATING_STATES[value]) {
      return this.translateService.instant(
        this.customTranslationsService.ESS_OPERATING_STATES[value] ?? value
      );
    }

    return value;
  }
}
